import { atom } from 'recoil';

export const langAtom = atom({
  key: 'langAtom', 
  default: 'it',       
});